(ns main.common
  (:require [very.re-frame.core :as rf]
            [css.core :refer [defstyled get-theme]]
            [css.icons :as icon]
            [css.form :as form]
            [css.vars :as vars]
            [cljss.core :as cljss]))

(defstyled grid-s :div
  {:display "grid"
   :grid-column (with-meta #(or % "auto") :grid-column)
   :grid-row (with-meta #(or % "auto") :grid-row)
   :grid-template-columns (with-meta #(or % "none") :grid-template-columns)
   :grid-template-rows (with-meta #(or % "none") :grid-template-rows)
   :grid-gap (with-meta #(or % "0") :grid-gap)
   :align-items (with-meta #(or % "stretch") :align-items)
   :justify-content (with-meta #(or % "flex-start") :justify-content)
   :text-align (with-meta #(or % "left") :text-align)
   :margin (with-meta #(or % "0") :margin)
   :padding (with-meta #(or % "0") :padding)
   :position (with-meta #(or % "static") :position)})

(defstyled box-s :div
  {:margin (with-meta #(or % "0") :margin)})

(defstyled divider-s :div
  {:height "1px"
   :background-color vars/border-light
   :margin "1rem 0"})

(defstyled header-wrapper-s :div
  {:display "flex"
   :flex-direction "row"
   :align-items "center"
   :border-bottom (str "2px solid " (get-theme :primary))
   :justify-content "space-between"
   :margin-bottom "1.5rem"
   :padding-bottom ".5rem"})

(defstyled header-title-s :h2
  {:font-size "24px"
   :color "#282828"
   :line-height "42px"})

(defstyled header-edit-s :button
  {:display "flex"
   :flex-direction "row"
   :text-decoration "none"
   :align-items "center"
   :padding "0"
   :background "none"
   :margin "0"
   :border "none"
   :border-bottom "1px solid transparent"
   :transition "border .25s ease-in"
   :cursor "pointer"
   :&:focus {:outline (str "1px dotted " vars/gray)
             :outline-offset "4px"}
   :&:hover {:border-color vars/gray}})

(defstyled edit-text-s :div
  {:color "#666"
   :font-size "13px"})

(defstyled edit-icon-s :div
  {:margin-right ".5rem"})

(defstyled nr-text-s :p
  {:color "#666666"
   :line-height "1.6rem"
   :margin-bottom "1rem"})

(defstyled data-row-s :div
  {:display "flex"
   :flex-direction "row"
   :margin-bottom ".6rem"
   :font-size (with-meta #(if (= % "large") "1.25rem" "1rem") :size)
   :line-height "1.45rem"})

(defstyled dr-label-s :label
  {:color "#666"
   :font-weight "bold"
   :margin-right ".3rem"})

(defstyled dr-value-s :div
  {:color "#666"})

(defstyled data-row-full-s :div
  {:display "flex"
   :flex-direction "row"
   :font-size (with-meta #(if (= % "large") "1.25rem" "1rem") :size)
   :line-height "1.45rem"
   :margin-bottom ".6rem"
   :width "100%"
   :justify-content "space-between"})

(defstyled form-page-s :div
  {})

(defstyled form-header-s :section
  {:margin "0 auto 3rem"
   :grid-column (with-meta #(or % "auto") :grid-column)})

(defstyled form-subtitle-s :h3
  {:display (with-meta #(if % "none" "block") :hide?)
   :margin "5rem auto 1rem"
   :text-align "center"
   :font-size "1.33rem"
   :font-weight "bold"
   :color (get-theme :primary)
   ::cljss/media {[[:max-width "768px"]]
                  {:text-align "left"}}})

(defstyled form-explain-s :h4
  {:font-size "1rem"
   :color vars/gray
   :line-height "1.56rem"
   :text-align "center"
   :margin-top "1rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:text-align "left"}}})

(defstyled form-title-s :h1
  {:text-align "center"
   :font-size "2.27rem"
   :line-height "3rem"
   :font-weight 300
   :margin (with-meta #(or % 0) :margin)
   ::cljss/media {[[:max-width "768px"]]
                  {:text-align "left"}}})

(defstyled form-s :form
  {:max-width (with-meta #(or % "55rem") :max-width)
   :width "100%"
   :margin "0 auto"
   ::cljss/media {[[:max-width "768px"]]
                  {:max-width "100%"}}})

(defstyled form-select-wrapper-s :div
  {:position "relative"
   :display "flex"
   :align-items "flex-end"})

(defstyled form-select-s :select
  {:font-size "1.5rem"
   :font-color (get-theme :primary)
   :border "none"
   :border-bottom "2px solid #AFAFAF"
   :border-radius "0"
   :background "none"
   :cursor "pointer"
   :padding ".5rem 2rem .5rem .5rem"
   :-webkit-appearance "none"
   :-webkit-border-radius "0px"
   :transition "border .25s ease-in"
   :&:focus {:outline "none"
             :border-bottom-color (get-theme :primary)}
   :after {:display "block"}})

(defstyled form-input-s :input
  {:font-size "1.5rem"
   :font-color (get-theme :primary)
   :border "none"
   :border-bottom "2px solid #AFAFAF"
   :padding ".25rem .5rem"
   :width "220px"
   :transition "border .25s ease-in"
   :&:focus {:outline "none"
             :border-bottom-color (get-theme :primary)}})

(defstyled form-input-number-s :input
  {:font-size "1.5rem"
   :font-color (get-theme :primary)
   :border "none"
   :border-bottom "2px solid #AFAFAF"
   :padding ".25rem .5rem"
   :width "100px"
   :transition "border .25s ease-in"
   :&:focus {:outline "none"
             :border-bottom-color (get-theme :primary)}})

(defn form-input-date [window props]
  (condp = window
    :future [form/future-date form-input-s props]
    :past [form/past-date form-input-s props]))

(defstyled form-row-s :div
  {:display "flex"
   :align-items "center"
   :flex-wrap "wrap"
   :flex-direction "row"
   :justify-content "center"
   :margin-bottom "1.5rem"
   :line-height "3rem"})

(defstyled form-select-icon-s :div
  {:position "absolute"
   :right ".5rem"
   :margin "auto"
   :bottom "0"
   :display "flex"
   :align-items "center"
   :top "0"
   :pointer-events "none"})

(defstyled center-s :div
  {:display "flex"
   :justify-content "center"
   :align-items "center"
   :grid-column (with-meta #(or % "auto") :grid-column)})

(defstyled bold-s :span
  {:font-weight "700"
   :padding (with-meta #(or % "0") :padding)})

(defstyled loading-s :div
  {:display "grid"
   :grid-template-columns "[left-gutter-start] minmax(1rem, 1fr) [left-gutter-end content-start] minmax(min-content, 82rem) [content-end right-gutter-start] minmax(1rem, 1fr) [right-gutter-end]"
   :justify-content "center"
   :align-items "center"})

(defstyled loading-body-s :div
  {:grid-column "content"})

(defn complete-button [{:keys [text on-click margin]}]
  [form/button {:on-click on-click
                :margin margin} text])

(defn no-results [{:keys [text button-text button-click]}]
  [:div
   [nr-text-s text]
   [complete-button {:text button-text
                     :on-click button-click}]])

(defn data-row [{:keys [label value size]}]
  (if value
    [data-row-s {:size size}
     [dr-label-s label]
     [dr-value-s value]]))

(defn data-row-full [{:keys [label value size]}]
  (if value
    [data-row-full-s {:size size}
     [dr-label-s label]
     [dr-value-s value]]))

(defn profile-section-header [{:keys [link text title data-test]
                               :or {data-test "not-used"}}]
  [header-wrapper-s
   [header-title-s title]
   (if (some? text)
     [header-edit-s {:on-click link
                     :data-test data-test}
      [edit-icon-s [icon/pencil]]
      [edit-text-s text]])])
